import React from 'react';

import { useReturnAuthorizationDetailActivityQuery } from 'generated/graphql';



export interface IData {
  storeId: string;
  orderId: string;
  customer: {
    fullName: string;
    email: string;
    phoneNumber: string;
  };
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useReturnAuthorizationDetailActivityQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        storeId: tuple.data?.returnAuthorization?.store.id ?? '',
        orderId: tuple.data?.returnAuthorization?.order.id ?? '',
        customer: {
          fullName: tuple.data?.returnAuthorization?.customer.fullName ?? '',
          email: tuple.data?.returnAuthorization?.customer.email ?? '',
          phoneNumber: tuple.data?.returnAuthorization?.customer.phoneNumber ?? ''
        }
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
